import { RoleEnum } from '~/api/types';

const getPriviligies = (roleId?: RoleEnum) => {
  if (roleId) {
    return {
      dataset: {
        canView: true,
        canEdit: [RoleEnum.ADMINISTRATOR, RoleEnum.DEVELOPER].includes(roleId),
      },
      manageDatasets: {
        canView: [RoleEnum.ADMINISTRATOR, RoleEnum.DEVELOPER].includes(roleId),
      },
      project: {
        canView: true,
        canCreate: [
          RoleEnum.ADMINISTRATOR,
          RoleEnum.DATA_SCIENTIST,
          RoleEnum.TESTING_GOD,
          RoleEnum.TESTER,
          RoleEnum.DEVELOPER,
        ].includes(roleId),
      },
      projectDetailsTab: {
        canEdit: [RoleEnum.OWNER, RoleEnum.ADMINISTRATOR, RoleEnum.DEVELOPER].includes(roleId),
      },
      studioIntegrationTab: {
        canView: [
          RoleEnum.OWNER,
          RoleEnum.WRITER,
          RoleEnum.READER,
          RoleEnum.ADMINISTRATOR,
          RoleEnum.DEVELOPER,
        ].includes(roleId),
        canEdit: [RoleEnum.OWNER, RoleEnum.WRITER, RoleEnum.ADMINISTRATOR, RoleEnum.DEVELOPER].includes(roleId),
      },
      emrCluster: {
        canCreate: [RoleEnum.OWNER, RoleEnum.WRITER, RoleEnum.ADMINISTRATOR, RoleEnum.DEVELOPER].includes(roleId),
      },
      workbenchTab: {
        canView: [
          RoleEnum.OWNER,
          RoleEnum.WRITER,
          RoleEnum.READER,
          RoleEnum.ADMINISTRATOR,
          RoleEnum.DEVELOPER,
        ].includes(roleId),
        canCreate: [RoleEnum.OWNER, RoleEnum.WRITER, RoleEnum.ADMINISTRATOR, RoleEnum.DEVELOPER].includes(roleId),
        canOperate: [RoleEnum.OWNER, RoleEnum.WRITER, RoleEnum.ADMINISTRATOR, RoleEnum.DEVELOPER].includes(roleId),
      },
      projectMembersTab: {
        canView: [RoleEnum.OWNER, RoleEnum.ADMINISTRATOR, RoleEnum.DEVELOPER].includes(roleId),
      },
      etlJobsTab: {
        canView: [RoleEnum.OWNER, RoleEnum.WRITER, RoleEnum.ADMINISTRATOR, RoleEnum.DEVELOPER].includes(roleId),
      },
    };
  } else return null;
};

export default getPriviligies;
